import { inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { PriceConfigService } from '../_services/price-config.service';

@Pipe({
  name: 'convertCurrency',
  pure: true
})
export class ConvertCurrencyPipe implements PipeTransform {
  private readonly priceConfigService = inject(PriceConfigService);
  private readonly currencyPipe = inject(CurrencyPipe);

  transform(priceStr: string, sourceCurrencyIsocode?: string): string {
    if (!this.priceConfigService.dblCurrencyActivated) return priceStr;

    const cleanedStr = priceStr.replace(/\s|\u00A0/g, '');

    const regex = /[\d.,]+/;
    const amountMatch = regex.exec(cleanedStr);
    if (!amountMatch) return priceStr;

    const amount = parseFloat(amountMatch[0].replace(',', '.'));
    if (isNaN(amount)) return priceStr;

    const conversionInfo = this.priceConfigService.getConversionInfo(sourceCurrencyIsocode);
    if (!conversionInfo) return priceStr;

    const convertedAmount = amount / conversionInfo.rate;

    return this.currencyPipe.transform(
      convertedAmount.toFixed(2),
      conversionInfo.targetIsoCode,
      'symbol',
      undefined,
      this.priceConfigService.getLang()
    ) ?? priceStr;
  }
}
